import "./ResponsiveNavMenu.scss";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Link } from "wouter";
import DownArrowSvg from "../../Atoms/DownArrowSvg/DownArrowSvg";
import RegularIconText from "../../Atoms/RegularIconText/RegularIconText";
import dropdownMenuContent from "../../../Services/DropdownMenuContent";
import content from "../NavMenu/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const ResponsiveNavMenu = () => {
	const { language } = useLanguageCtx();

	return (
		<div className="responsiveNavMenu">
			<Link href="/">
				<div className="responsiveNavMenu--link_without_accordion-container">
					<p className="responsiveNavMenu--link_without_accordion-text">
						{content[language].inicio}
					</p>
				</div>
			</Link>

			{/* Acerca Accordion */}
			<Accordion className="responsiveNavMenu--accordion">
				<AccordionSummary expandIcon={<DownArrowSvg inResponsiveNavMenu />}>
					{content[language].about}
				</AccordionSummary>
				<AccordionDetails>
					{dropdownMenuContent.acerca.map((content, index) => (
						<div className="responsiveNavMenu--link-container">
							<Link href={content.to} key={index}>
								<div>
									<RegularIconText
										icon={content.icon}
										boldText={content[language].boldText}
										inResponsiveNavbar
									/>
								</div>
							</Link>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			{/* Industrias Accordion */}
			<Accordion className="responsiveNavMenu--accordion">
				<AccordionSummary expandIcon={<DownArrowSvg inResponsiveNavMenu />}>
					{content[language].industrias}
				</AccordionSummary>
				<AccordionDetails>
					{dropdownMenuContent.industrias.map((content, index) => (
						<div className="responsiveNavMenu--link-container">
							<Link href={content.to} key={index}>
								<div>
									<RegularIconText
										icon={content.icon}
										boldText={content[language].boldText}
										inResponsiveNavbar
									/>
								</div>
							</Link>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			{/* Familias Accordion */}
			<Accordion className="responsiveNavMenu--accordion">
				<AccordionSummary expandIcon={<DownArrowSvg inResponsiveNavMenu />}>
					{content[language].familias}
				</AccordionSummary>
				<AccordionDetails>
					{dropdownMenuContent.familias.map((content, index) => (
						<div className="responsiveNavMenu--link-container">
							<Link href={content.to} key={index}>
								<div>
									<RegularIconText
										icon={content.icon}
										boldText={content[language].boldText}
										inResponsiveNavbar
									/>
								</div>
							</Link>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			{/* Soluciones Accordion */}
			<Accordion className="responsiveNavMenu--accordion">
				<AccordionSummary expandIcon={<DownArrowSvg inResponsiveNavMenu />}>
					{content[language].soluciones}
				</AccordionSummary>
				<AccordionDetails>
					{dropdownMenuContent.soluciones.map((content, index) => (
						<div className="responsiveNavMenu--link-container">
							<Link href={content.to} key={index}>
								<div>
									<RegularIconText
										icon={content.icon}
										boldText={content[language].boldText}
										inResponsiveNavbar
									/>
								</div>
							</Link>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			{/* Aliados Accordion */}
			<Accordion className="responsiveNavMenu--accordion">
				<AccordionSummary expandIcon={<DownArrowSvg inResponsiveNavMenu />}>
					{content[language].aliados}
				</AccordionSummary>
				<AccordionDetails>
					{dropdownMenuContent.aliados.map((content, index) => (
						<div className="responsiveNavMenu--link-container">
							<Link href={content.to} key={index}>
								<div>
									<RegularIconText
										icon={content.icon}
										boldText={content[language].boldText}
										inResponsiveNavbar
									/>
								</div>
							</Link>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			{/* Recursos Accordion */}
			<Accordion className="responsiveNavMenu--accordion">
				<AccordionSummary expandIcon={<DownArrowSvg inResponsiveNavMenu />}>
					{content[language].recursos}
				</AccordionSummary>
				<AccordionDetails>
					{dropdownMenuContent.recursos.map((content, index) => (
						<div className="responsiveNavMenu--link-container">
							<Link href={content.to} key={index}>
								<div>
									<RegularIconText
										icon={content.icon}
										boldText={content[language].boldText}
										inResponsiveNavbar
									/>
								</div>
							</Link>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			<Link href="/contacto">
				<div className="responsiveNavMenu--link_without_accordion-container">
					<p className="responsiveNavMenu--link_without_accordion-text no-space">
						{content[language].contacto}
					</p>
				</div>
			</Link>
		</div>
	);
};

export default ResponsiveNavMenu;
